// removed by extract-text-webpack-plugin
module.exports = {"block":"_1_8u7wnDfShzBmdqy4K691","text":"_34YFa-vGw9aDRkakuXysL0","heading":"_2Ig6jsQ04Cdo00wHl_qd1f","intro":"_1xi4AYCn-aY-cB27e3r7Ex"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DoYouHaveQuestionsBlock/DoYouHaveQuestionsBlock.module.scss
// module id = 749
// module chunks = 0